import React, { Component } from 'react';
import store from "../../store/index"
import { connect } from "react-redux"
import { eventBus } from '../../utils/tool';
import { ethers, BigNumber } from 'ethers';
import SweetAlert2 from 'react-sweetalert2';
import throttle from 'lodash/debounce';
import Spinner from 'react-bootstrap/Spinner';
import ApproveModal from '../Staking/components/ApproveModal/index'
import copy from 'copy-to-clipboard'
import { getProviderWithChainId, initProvider } from '../../utils/config';
import { Contract, Provider } from 'ethers-multicall';
import UserListTable from './Components/UserListTable/index'
// import topBanner from '../../assets/banner.png'
// import bodyBg from '../../assets/bodyBg.png'
// import boxBg from '../../assets/boxBg.png'
// import titleBg from '../../assets/titleBg.png'
// import btn1 from '../../assets/btn1.png'

// const 
const abi = [
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "invitor",
                "type": "address"
            }
        ],
        "name": "buyToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "claimBalance",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "to",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "claimToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "EnforcedPause",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ExpectedPause",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "initialize",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "InvalidInitialization",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "NotInitializing",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "OwnableInvalidOwner",
        "type": "error"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "OwnableUnauthorizedAccount",
        "type": "error"
    },
    {
        "inputs": [],
        "name": "ReentrancyGuardReentrantCall",
        "type": "error"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint64",
                "name": "version",
                "type": "uint64"
            }
        ],
        "name": "Initialized",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "Paused",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "inviter",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "rewardAmount",
                "type": "uint256"
            }
        ],
        "name": "SentReward",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "Unpaused",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "inviter",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            }
        ],
        "name": "UpdateInvitor",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "invitor",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "payAmount",
                "type": "uint256"
            }
        ],
        "name": "buySuccess",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "address",
                "name": "newInvitor",
                "type": "address"
            }
        ],
        "name": "multiInvitor",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addresses",
                "type": "address[]"
            },
            {
                "internalType": "bool",
                "name": "status",
                "type": "bool"
            }
        ],
        "name": "multiSetWLs",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "newBeginTime",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "newEndTime",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "pause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setBeginTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newU",
                "type": "address"
            }
        ],
        "name": "setCurrencyAddress",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setEndTime",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newAddr",
                "type": "address"
            }
        ],
        "name": "setFundReceiveAddress",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "newValue",
                "type": "uint256"
            }
        ],
        "name": "setHardCup",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256[]",
                "name": "newValue",
                "type": "uint256[]"
            }
        ],
        "name": "setInvitorRewardPercentList",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "token",
                "type": "address"
            }
        ],
        "name": "setMainToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "unpause",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_usersId",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyerGotAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "buyerPayAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "currencyAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "fundReceiveAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getAllUser",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "getBalanceOf",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "getRewardCurrency",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "userId",
                "type": "uint256"
            }
        ],
        "name": "getUserById",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "account",
                "type": "address"
            }
        ],
        "name": "getUserId",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getUsersCount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserSubordinateInfo",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "_ind",
                "type": "uint256"
            }
        ],
        "name": "getUserSubordinateInfoById",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "id",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "addr",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "inviter",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "payAmount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct ido.userInfo",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "getUserSubordinateTotalBuyU",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "totalBuy",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "hardCup",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "idoBeginTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "idoEndTime",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxPayPerUser",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "user",
                "type": "address"
            }
        ],
        "name": "inviterCountsForUser",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorMapping",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorNumbs",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "invitorNumbs2",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "invitorRewardPercentList",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "lenOfInvitorRewardPercentList",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "mainToken",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "paused",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "sellCurrencyAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "sellMainTokenAmount",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "whitelistedUsers",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const tokenAbi = [{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "guy", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "approve", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "src", "type": "address" }, { "name": "dst", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "wad", "type": "uint256" }], "name": "withdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "dst", "type": "address" }, { "name": "wad", "type": "uint256" }], "name": "transfer", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "deposit", "outputs": [], "payable": true, "stateMutability": "payable", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }, { "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "payable": true, "stateMutability": "payable", "type": "fallback" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": true, "name": "guy", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": true, "name": "dst", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "dst", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Deposit", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "src", "type": "address" }, { "indexed": false, "name": "wad", "type": "uint256" }], "name": "Withdrawal", "type": "event" }]


const TokenSymbol = 'UBC'
const initData = {
    img: "/img/logo.jpg",
    blockchain: "/img/binance.png",
    title: "MetaDoge",
    reg_date: "2022-11-30",
    raise: "100k",
    val: "2.8M",
    allocation: "$0",
    progress: "25%",
    mecha: "0/100,069 MECHA",
    busd: "0 BUSD",
    actionBtn: "Contribute", // 提取代币 参与IDO
    video_img: "/img/thumb_6.png",
    video_icon: "fa-solid fa-play",
    video_link: "https://www.youtube.com/watch?v=fzBTvDraO5U",
    idoToken: "",
    total: "", // 当前购买总数
    purchaseCap: "", // 每个人能买多少
    hardCap: 0, // 硬顶
    startTime: "", // 开始时间戳
    endTime: "" // 结束时间戳
}

const summaryData = {
    title: "Project Summary",
    content_1: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content_2: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."
}

const overviewData = {
    title: "Project Overview",
    list_heading: "Lorem ipsum dolor sit",
    content: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.",
}

const tokenmetricsData = {
    title: "Token Metrics",
    content: "Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar."
}

const roadmapData = {
    title: "Roadmap",
    content_1: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.",
    content_2: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth."
}

const socialData = [
    // {
    //     id: "1",
    //     link: "",
    //     icon: "fab fa-twitter"
    // },
    {
        id: "2",
        link: "https://t.me/GoldenDoge_BSC",
        icon: "fab fa-telegram"
    },
    // {
    //     id: "3",
    //     link: "https://hklr.gitbook.io/xiang-gang-shi-zi-shan-ji-jin-hui",
    //     icon: "fas fa-globe"
    // },
    // {
    //     id: "4",
    //     link: "discord",
    //     icon: "fab fa-discord"
    // }
]

const overviewList = [
    {
        id: "1",
        content: "Far far away",
    },
    {
        id: "2",
        content: "Behind the word mountains",
    },
    {
        id: "3",
        content: "Far from the countries Vokalia and Consonantia",
    },
    {
        id: "4",
        content: "There live the blind texts",
    }
]

const tokenList = [
    {
        id: "1",
        title: "Fundraised:",
        content: "$500,000",
    },
    {
        id: "2",
        title: "Platfrom Raise:",
        content: "$120,000 + $5,000",
    },
    {
        id: "3",
        title: "Price:",
        content: "$0.05",
    },
    {
        id: "4",
        title: "Lock-up:",
        content: "25% unlocked on TGE, 4 months cliff, then 5% on a monthly basis",
    }
]

class ProjectSingle extends Component {
    constructor() {
        super()


        // const idoContract = "0xBcAcbb12846440965fEbf96158Af1E30DEb76C9E"
        // // const payTokenContract = '0x55d398326f99059ff775485246999027b3197955' // 要支付的代币的合约
        // const payTokenContract = '0xab1a4d4f1d656d2450692d237fdd6c7f9146e814'
        // // const nodeRpc = "https://bsc-dataseed4.ninicoin.io"
        // const nodeRpc = 'https://data-seed-prebsc-1-s1.binance.org:8545/'
        // const CHAIN_ID = 97
        // // const CHAIN_ID = 56
        // const perPrice = 10 // 每份价格


        this.state = {
            idoContract: '0xa1e45c06a83932ba70c3dd6ba3067d5f3d5fa021',
            payTokenContract: '0x55d398326f99059ff775485246999027b3197955',
            nodeRpc: 'https://bsc-dataseed4.ninicoin.io',
            chainId: 56,
            perPrice: 10,



            maxPayPerUser: 0,
            endTime: 1741179600,
            hardCup: 0,
            canBuyCount: 50,
            totalCount: 0,
            invitorReward: 0,
            invitorNumbs2: 0,
            isAdmin: false,
            currentPage: 0,
            allList: [],
            invitorList: [],
            invitorPage: 0,
            showStakeModal: false,
            initData: {},
            summaryData: {},
            overviewData: {},
            soldUSDTAmount: 0,
            tokenmetricsData: {},
            roadmapData: {},
            socialData: [],
            overviewList: [],
            tokenList: [],
            invitorAddress: '',
            invotorInvitorAddress: '',
            buyAmount: 0, // 已购入数量
            preBuyAmount: 0, // 预计购入数量
            swal: {},
            inputValue: '',
            linkInvitor: '',
            buyLoading: false,
            ethBalance: 0,
            invitorNumbers: 0, // 下级人数
            invitorRefUSDTAmount: 0, // 下级购买的总USDT数量
            canClaimedAmount: 0,
        }
        this.handleInput = throttle(this.handleBuyInputAmount, 300)

    }
    showMessageModal(info) {
        this.setState({
            swal: {
                show: false,
                title: '',
                text: '',
            }
        }, () => {
            this.setState({
                swal: {
                    ...info
                }
            })
        })

    }

    async getAllList(page) {
        // 获取全部列表
        // 获取邀请者列表
        // 获取 邀请者地址、邀请者购买usdt总量、邀请者的下级数量

        const account = this.state.account
        const perPage = 15
        const offset = (page - 1) * perPage
        // const provider = this.initProvider()
        const provider = getProviderWithChainId(this.state.chainId)
        let ethcallProvider = new Provider(provider)

        ethcallProvider = await initProvider(ethcallProvider, this.state.chainId)

        const StructInfo = `tuple(uint256 id,address addr,address inviter,uint256 payAmount)`
        const abi = [
            `function getUserById(uint256 userId) public view returns (${StructInfo} memory)`,
            `function getUserSubordinateInfoById(address userAddress, uint256 index) public view returns (${StructInfo}})`,
            'function inviterCountsForUser(address userAddress) public view returns (uint256)'
        ]
        const contract = new Contract(this.state.idoContract, abi)
        const calls = []
        console.log('这里是abi', abi, this.state.totalCount, offset)

        for (let i = this.state.totalCount - offset - 1; i >= 0; i--) {
            calls.push(contract.getUserById(i))
        }
        const res = await ethcallProvider.all(calls)

        const calls2 = []
        res.forEach(item => {
            calls2.push(contract.inviterCountsForUser(item.addr))
        })
        const res2 = await ethcallProvider.all(calls2)
        console.log('这里是res', res, res2)
        const allList = res.map((item, ind) => {
            return {
                id: item.id.toString(),
                addr: item.addr,
                invitor: item.inviter,
                payAmount: item.payAmount.toString() / 1e18,
                inviteCount: res2[ind].toString()
            }
        })
        console.log('当前全部列表为', allList)
        if (allList.length > 0) {
            this.setState({
                allList,
                currentPage: page
            })
        }
    }

    async getInviterList(page) {
        // 获取邀请者列表
        // 获取 邀请者地址、邀请者购买usdt总量、邀请者的下级数量

        console.log('正在获取inviter列表')
        const account = this.state.account
        const perPage = 15
        const offset = (page - 1) * perPage
        // const provider = this.initProvider()
        const provider = getProviderWithChainId(this.state.chainId)

        const contract = new ethers.Contract(this.state.idoContract, abi, provider)
        const list = await contract.getUserSubordinateInfo(this.state.account)
        console.log('这里是list', list)
        const invitorList = list.map((item, ind) => {
            return {
                id: item.id.toString(),
                addr: item.addr,
                invitor: item.inviter,
                payAmount: item.payAmount.toString() / 1e18,
                // inviteCount: res2[ind].toString()
            }
        })
        if (invitorList.length > 0) {
            this.setState({
                invitorList,
                invitorPage: page
            })
        }
        // let ethcallProvider = new Provider(provider)

        // ethcallProvider = await initProvider(ethcallProvider, this.state.chainId)

        // const StructInfo = `tuple(uint256 id,address addr,address inviter,uint256 payAmount)`
        // const abi = [
        //     `function getUserSubordinateInfoById(address userAddress, uint256 index) public view returns (${StructInfo}})`,
        //     'function inviterCountsForUser(address userAddress) public view returns (uint256)'
        // ]
        // console.log('这里是abi', abi)
        // const contract = new Contract(this.state.idoContract, abi)
        // const calls = []
        // for (let i = this.state.invitorNumbers - offset - 1; i >= 0; i--) {
        //     calls.push(contract.getUserSubordinateInfoById(account, i))
        // }
        // const res = await ethcallProvider.all(calls)

        // const calls2 = []
        // res.forEach(item => {
        //     calls2.push(contract.inviterCountsForUser(item.addr))
        // })
        // const res2 = await ethcallProvider.all(calls2)

        // const invitorList = res.map((item, ind) => {
        //     return {
        //         id: item.id.toString(),
        //         addr: item.addr,
        //         invitor: item.inviter,
        //         payAmount: item.payAmount.toString() / 1e18,
        //         inviteCount: res2[ind].toString()
        //     }
        // })
        // console.log('邀请者列表为', invitorList)
        // if (invitorList.length > 0) {
        //     this.setState({
        //         invitorList,
        //         invitorPage: page
        //     })
        // }
    }

    handleBuyInputAmount() {
        console.log(this.state.inputValue)
        // 去列表中获取
        if (this.state.account) {
            const provider = new ethers.providers.JsonRpcProvider(this.state.nodeRpc)
            const contract = new ethers.Contract(this.state.idoContract, abi, provider)
            contract.ifBuy(ethers.utils.parseUnits(this.state.inputValue + '', 18))
                .then(res => {
                    // console.log('预计购买', res.toString() / 1e18)
                    this.setState({
                        preBuyAmount: res.toString() / 1e18
                    })
                })
        }
    }

    async initProvider() {
        let provider = null
        let chainId = this.state.chainId
        if (window.ethereum) {
            provider = new ethers.providers.Web3Provider(window.ethereum)
        }
        if (!provider) {
            // 直接走获取provider的逻辑
            provider = getProviderWithChainId(chainId)
        }

        return provider


    }



    componentDidMount() {
        this.setState({
            initData: initData,
            summaryData: summaryData,
            overviewData: overviewData,
            tokenmetricsData: tokenmetricsData,
            roadmapData: roadmapData,
            socialData: socialData,
            overviewList: overviewList,
            tokenList: tokenList,
            account: ""
        });


        if (window.location.href.indexOf('fix') > -1) {
            const idoContract = prompt('ido合约:', this.state.idoContract)
            const payTokenContract = prompt('支付代币合约(USDT):', this.state.payTokenContract)
            const nodeRpc = prompt('node rpc 地址:', this.state.nodeRpc)
            const chainId = prompt('chainId:', this.state.chainId)
            const perPrice = prompt('每份 USDT 数量:', this.state.perPrice)

            this.setState({
                idoContract,
                payTokenContract,
                nodeRpc,
                chainId,
                perPrice
            }, () => {
                eventBus.addListener("walletConnect", this.walletConnect.bind(this))
            })


        } else {
            eventBus.addListener("walletConnect", this.walletConnect.bind(this))
        }




        // 获取信息
        // setTimeout(() => {
        //     // 获取连接的钱包
        // }, 2000);
    }
    componentWillUnmount() {
        eventBus.removeListener("walletConnect", this.walletConnect.bind(this))
    }

    handleBuyLogic(amount) {
        if (this.state.buyLoading) {
            return
        }
        const a = parseFloat(amount)


        console.log('aaaa', amount)

        if (this.state.payTokenBalance < a) {
            this.setState({
                swal: {}
            }, () => {
                this.setState({
                    swal: {
                        show: true,
                        title: '余额不足'
                    }
                })
            })
            console.log('当前余额', this.state.payTokenBalance)
            return
        }


        // console.log(111)
        // store.dispatch({ type: 'add' })
        // alert("当前项目为示例项目, 仅供示范, 无法参与IDO")
        this.setState({
            // buyLoading: true,
            showStakeModal: true
        })

        // 调起授权框
        // 设置授权数量
        // 调用其中的授权按钮
        // 设置数量
        this.stakeModalRef.setApproveInfo({
            amount: amount,
            tokenDecimals: 18,
            stakeContract: this.state.idoContract,
            tokenAddress: this.state.payTokenContract,
            currentWallet: this.state.account,
            stakeMax: false,
            amountBigNumber: ethers.utils.parseUnits(amount + '', 18) // 最终授权数量
        }).then(() => {
            this.stakeModalRef.handleLogic() // 设置数量

        })
    }

    walletConnect(v) {
        console.log('监控到账户连接', v)
        if (v.account) {
            // 执行初始化操作
            this.setState({
                account: v.account
            }, () => {
                this.fetchData()
            })
        }
    }

    async fetchData() {
        const provider = new ethers.providers.JsonRpcProvider(this.state.nodeRpc)
        const search = window.location.search
        const params = new URLSearchParams(search);
        const invitor = params.get('invitor')
        if (invitor) {
            this.setState({
                linkInvitor: invitor
            })
        }

        console.log('连接钱包是', this.state.account)
        if (this.state.account) {
            // 获取当前地址的上级地址
            // 获取当前邀请链接的上级地址
            // 1. 获取已购买的代币数量(需要连接钱包)
            const contract = new ethers.Contract(this.state.idoContract, abi, provider)
            const token = new ethers.Contract(this.state.payTokenContract, tokenAbi, provider)
            contract.invitorMapping(this.state.account)
                .then(res => {
                    if (res !== '0x0000000000000000000000000000000000000000') {
                        console.log('邀请人是', res)
                        this.setState({
                            invitorAddress: res
                        })
                    }

                })

            contract.idoEndTime().then(res => {
                console.log('结束时间', res.toString())
                this.setState({
                    endTime: res.toString()
                })
                // 通过 eventBus 发送时间戳给 Breadcrumb 组件
                eventBus.emit('updateEndTime', parseInt(res.toString()) * 1000)
            })

            // 获取当前硬顶
            contract.hardCup().then(res => {
                console.log('当前硬顶是：', res.toString() / 1e18)
                this.setState({
                    hardCup: (res.toString() / 1e18).toFixed(0)
                })
            })

            contract.sellCurrencyAmount().then(res => {
                console.log('已售出的USDT数量', res.toString() / 1e18)
                this.setState({
                    soldUSDTAmount: res.toString() / 1e18
                })

            })

            contract.inviterCountsForUser(this.state.account)
                .then(res => {
                    console.log('下级人数', res.toString(), this.state.account)
                    this.setState({
                        invitorNumbers: parseInt(res.toString())
                    }, () => {
                        // 如果邀请数超过0, 则获取下级列表
                        if (this.state.invitorNumbers > 0) {
                            // 获取邀请奖励
                            // contract.getRewardUSDT(this.state.account)
                            //     .then((rewardU) => {
                            //         console.log('邀请奖励', rewardU.toString() / 1e18)
                            //         this.setState({
                            //             invitorReward: rewardU.toString() / 1e18
                            //         })

                            //     })
                            // contract.invitorNumbs2(this.state.account).then(res => {
                            //     console.log('下级人数2', res.toString())
                            //     this.setState({
                            //         invitorNumbs2: parseInt(res.toString())
                            //     })

                            // })
                            this.getInviterList(1)
                        }
                    })


                })

            // 判断是否在白名单中, 如果在白名单中, 显示全部列表
            contract.whitelistedUsers(this.state.account)
                .then(res => {
                    console.log('是否在白名单中', res)
                    if (res) {
                        contract.getUsersCount().then(r => {
                            console.log('总人数', r.toString())
                            this.setState({
                                totalCount: parseInt(r.toString()),
                                isAdmin: true
                            }, () => {
                                // 获取全部列表第一页
                                this.getAllList(1)
                            })

                        })
                    }

                })


            // contract.invitor_refUSDTAmount(this.state.account)
            //     .then(res => {
            //         console.log('下级购买总量', res.toString() / 1e18)
            //         this.setState({
            //             invitorRefUSDTAmount: res.toString() / 1e18
            //         })
            //     })

            // contract.getCanBeClaimBuyerToken_2(this.state.account)
            //     .then(res => {
            //         console.log('可领取的代币数量', res.toString() / 1e18)
            //         this.setState({
            //             canClaimedAmount: res.toString() / 1e18
            //         })
            //     })

            // 获取还可以买的份数
            // contract.getUserCanMaxBuyCount(this.state.account).then(res => {
            //     console.log('还可以买的份数', res.toString())
            //     this.setState({
            //         canBuyCount: parseInt(res.toString()),
            //         inputValue: parseInt(res.toString())
            //     })

            // })

            contract.maxPayPerUser().then(res => {
                console.log('单地址购买量', res.toString() / 1e18)
                this.setState({
                    maxPayPerUser: res.toString() / 1e18
                })
            })

            contract.buyerPayAmount(this.state.account).then(res => {
                console.log('已购买数量', res.toString() / 1e18)
                this.setState({
                    buyAmount: res.toString() / 1e18
                })
            })

            // contract._usersId(this.state.account).then(res => {
            //     console.log('当前用户信息id', res)
            //     contract.getUserById(res).then(r => {
            //         if (r.addr.toLowerCase() === this.state.account.toLowerCase()) {
            //             console.log('当前用户信息', r)
            //             this.setState({
            //                 buyAmount: r.payAmount.toString() / 1e18
            //             })
            //         }


            //     })
            // })
            if (invitor) {
                contract.invitorMapping(invitor)
                    .then(res => {
                        if (res !== '0x0000000000000000000000000000000000000000') {
                            this.setState({
                                invotorInvitorAddress: res
                            })
                        }

                    })
            }
            provider.getBalance(this.state.account)
                .then(res => {
                    console.log('余额是', res.toString() / 1e18)
                    this.setState({
                        ethBalance: parseFloat(res.toString() / 1e18)
                    })
                })


            token.balanceOf(this.state.account)
                .then(res => {
                    console.log('payToken余额是', res.toString() / 1e18)
                    this.setState({
                        payTokenBalance: parseFloat(res.toString() / 1e18)
                    })
                })



        }

        // const ethcallProvider = new Provider(provider);
        // await ethcallProvider.init();
        // const abi = [
        //     'function ido() external view returns(address)',
        //     'function purchaseCap() public view returns(uint256)',
        //     'function totalPurchasedAmount() public view returns(uint256)',
        //     'function hardCup() public view returns(uint256)',
        //     'function startTime() public view returns(uint256)',
        //     'function endTime() public view returns(uint256)',
        //     'function whitelist(address _addr) public view returns(bool)',
        //     'function _dontNeedWLtoBuy(address _addr) public view returns(bool)',
        //     'function purchasedAmounts(address _addr) public view returns(uint256)',
        //     'function invitorAmount(address _addr) public view returns(uint256)',
        //     'function claimedAmounts(address _addr) public view returns(uint256)',
        //     'function claimedInvitorAmount(address _addr) public view returns(uint256)',
        //     'function _invitor(address _addr) public view returns(address)',
        // ]
        // const ido = new Contract(this.state.idoContract, abi)

        // // 获取用户代币余额
        // const calls = [
        //     ido.ido(),
        //     ido.purchaseCap(),
        //     ido.totalPurchasedAmount(),
        //     ido.hardCup(),
        //     ido.startTime(),
        //     ido.endTime(),
        // ]
        // const res = await ethcallProvider.all(calls)
        // console.log(res)
        // this.setState({
        //     initData: {
        //         ...this.state.initData,
        //         idoToken: res[0],
        //         purchaseCap: res[1].toString() / 1e18,
        //         total: res[2].toString() / 1e18,
        //         hardCap: res[3].toString() / 1e18,
        //         startTime: res[4].toString() / 1e18,
        //         endTime: res[5].toString() / 1e18
        //     }
        // })

        // // 已经连接钱包, 获取连接数量
        // if (this.state.account) {
        //     // 是否在白名单里
        //     // 是否在不需要白名单也能买的账户里
        //     // 付款数量
        //     // 可领取的推荐奖励数
        //     // 已领取的推荐奖励数
        //     // claimedAmounts 已领取代币数
        //     // 'function whitelist(address _addr) public view returns(bool)',
        //     //     'function _dontNeedWLtoBuy(address _addr) public view returns(bool)',
        //     //     'function purchasedAmounts(address _addr) public view returns(uint256)',
        //     //     'function invitorAmount(address _addr) public view returns(uint256)',
        //     //     'function claimedAmounts(address _addr) public view returns(uint256)',
        //     //     'function claimedInvitorAmount(address _addr) public view returns(uint256)',
        //     //     'function _invitor(address _addr) public view returns(address)',
        //     const account = this.state.account
        //     const c2 = [
        //         ido.whitelist(account),
        //         ido._dontNeedWLtoBuy(account),
        //         ido.purchasedAmounts(account),
        //         ido.invitorAmount(account),
        //         ido.claimedAmounts(account),
        //         ido.claimedInvitorAmount(account),
        //         ido._invitor(account),
        //     ]
        //     const r = await ethcallProvider.all(c2)
        //     console.log('钱包相关', r)
        //     this.setState({
        //         initData: {
        //             ...this.state.initData,
        //             inWhitelist: r[0],
        //             inNotWlToBuy: r[1],
        //             purchasedAmounts: r[2].toString() / 1e18,
        //             invitorAmount: r[3].toString() / 1e18,
        //             claimedAmounts: r[4].toString() / 1e18,
        //             claimedInvitorAmount: r[5].toString() / 1e18,
        //             _invitor: r[6].toString() / 1e18
        //         }
        //     })
        // }


    }

    handleErr(e) {
        console.log(e)
        let tt = ''
        if (e.reason) {
            tt = e.reason
        } else {
            tt = JSON.stringify(e)
        }

        if (tt.indexOf('cant claim') > -1) {
            tt = '暂未开放领取'
        }
        if (tt.indexOf('ount<axlamCunt') > -1) {
            tt = '领取次数达到上限'
        }
        if (tt.indexOf('zero token can be claim') > -1) {
            tt = '暂无可领取代币'
        }
        if (tt.indexOf('not enough token') > -1) {
            tt = '代币数量不足'
        }


        this.showMessageModal({
            show: true,
            title: '错误',
            text: tt

        })
    }

    // 根据合约, 获取IDO信息
    // 参与IDO
    // 领取代币
    // 上级地址
    // 分级数量
    // IDO有多种方式: 有硬顶 没硬顶 不显示已购买数量 参与数量 一份=多少代币 

    render() {
        return (
            <>
                {/* <div style={{ backgroundImage: `url(${bodyBg})`, backgroundSize: '100% auto' }}>
                    <div style={{ backgroundImage: `url(${topBanner})`, height: '600px', backgroundSize: '100% auto' }}>

                        <div style={{ display: 'flex', position: 'relative', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <img alt='' src={titleBg} style={{ width: '250%', height: '60px' }} />
                            <div style={{ marginTop: '-46px', color: '#ffffff', fontSize: '20px', fontWeight: 'bold' }}>龙泽加密资产</div>
                        </div>
                    </div>
                    <div>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', height: '50px', marginTop: '-35px', justifyContent: 'center', position: 'relative' }}>
                            <img alt='' src={btn1} style={{ width: '90%', position: 'absolute', top: '0px' }} />
                            <div style={{ color: '#27E382', fontWeight: 'bold', zIndex: '100', fontSize: '20px' }}>Wallet Connect</div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '40px' }}>
                        <div style={{ backgroundImage: `url(${boxBg})`, backgroundSize: '100% auto', width: '94%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
                            <div style={{ width: '120px', height: '120px', backgroundColor: '#198CFF', marginTop: '40px', borderRadius: '10px' }} >这里是图片</div>
                            <div style={{ fontSize: '22px', fontWeight: 'bold', color: '#FFFFFF', marginTop: '20px' }}>
                                LZ
                            </div>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '10px', position: 'relative' }}>
                                <div style={{ width: '85%', height: '22px', borderRadius: '11px', backgroundColor: 'rgb(166,176,201)', position: 'relative', border: '0px solid rgb(166,176,201)' }}>
                                    <div style={{ width: '50%', height: '22px', borderRadius: '11px', backgroundImage: `linear-gradient(to right, #27E382, #1397C1, #004CFF)`, position: 'absolute', top: '0', left: '0', border: '1.5px solid #27E382' }}></div>

                                </div>
                                <div style={{ position: 'absolute', top: '0', color: '#ffffff', fontSize: '15px' }}>
                                    6000份
                                </div>
                            </div>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px', position: 'relative' }}>
                                <div style={{ width: '85%', height: '42px', borderRadius: '21px', backgroundColor: 'rgba(0,0,0,0.52)', position: 'relative', border: '2px solid #ffffff' }}>
                                    <input style={{ width: '100%', height: '100%', border: 'none' }} placeholder='请输入铸造份数' className='input-mint-count' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div > */}

                <section className="item-details-area">
                    <ApproveModal
                        invitor={this.state.linkInvitor || ''}
                        onRef={node => this.stakeModalRef = node} handleClose={() => {
                            this.setState({
                                showStakeModal: false
                            })
                        }} ok={() => {
                            this.fetchData()
                        }} show={this.state.showStakeModal} />





                    <div className="container">
                        <div className="row justify-content-between">
                            <div className="col-12 col-lg-5">
                                <div className="card project-card no-hover">
                                    <div className="media">
                                        <img className="card-img-top avatar-max-lg" src='https://token-monitor.s3.amazonaws.com/1741506720414screenshot-20250309-155141.png' alt="" />
                                        <div className="media-body ml-4 ">
                                            <h4 className="m-0">{TokenSymbol} </h4>
                                            <div className="media-body-b">
                                                <div className="countdown-times">
                                                    <h6 className="my-2">已购入数量:</h6>
                                                    <div style={{ height: "20px" }} className="countdown d-flex" data-date={this.state.initData.reg_date} >
                                                        {this.state.buyAmount.toFixed(2)} USDT
                                                    </div>

                                                </div>
                                                {/* <div className="countdown-times">
                                                <h6 className="my-2">可购入份数:</h6>
                                                <div style={{ height: "20px" }} className="countdown d-flex"  >
                                                    {this.state.canBuyCount}
                                                </div>
                                            </div> */}
                                            </div>


                                        </div>
                                    </div>
                                    <div className="card-body">


                                        <div className="item-progress" style={{ marginBottom: '10px' }}>
                                            <div className="progress mt-0">
                                                {this.state.hardCup > 0 && <div className="progress-bar" role="progressbar" style={{ width: ((parseInt(this.state.soldUSDTAmount / this.state.hardCup * 100)) + '%') }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}> {parseInt(this.state.soldUSDTAmount)} USDT</div>}
                                            </div>
                                            <div className="progress-sale d-flex justify-content-between mt-3">
                                                <span>0</span>
                                                <span> {this.state.hardCup} USDT</span>
                                            </div>
                                        </div>

                                        {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span style={{ width: '47%', marginLeft: '5px' }} onClick={async () => {
                                            this.handleBuyLogic(100)

                                        }} className="btn btn-bordered-white btn-smaller" href="/login">
                                            {!this.state.buyLoading && <div>
                                                购买100USDT
                                            </div>}

                                        </span>
                                        <span style={{ width: '47%' }} onClick={async () => {
                                            // this.inputValue = 100
                                            this.handleBuyLogic(300)

                                        }} className="btn btn-bordered-white btn-smaller" href="/login">
                                            {!this.state.buyLoading && <div>
                                                购买300USDT
                                            </div>}

                                        </span>
                                    </div> */}
                                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                                            <div className="project-input-aa">
                                                <div style={{ position: 'relative' }} className="project-input-a">
                                                    <input onChange={(e) => {
                                                        console.log(e)
                                                        this.setState({
                                                            inputValue: e.target.value
                                                        }, () => {
                                                            this.handleInput(e)
                                                        })

                                                    }} style={{ 'borderRadius': '20px', height: '48px' }} type="text" defaultValue={this.state.inputValue} placeholder="输入要铸造的份数" required="required" />
                                                    <div style={{ position: 'absolute', top: '0px', right: '15px', height: '48px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                                        份
                                                    </div>
                                                </div>

                                                {/* <div style={{ width: '100%', display: 'flex', flexDirection: 'row-reverse', marginTop: '10px', fontSize: '12px' }}>预计花费100USDT</div> */}
                                            </div>

                                            <div onClick={() => {

                                                // 购买数量
                                                const n = parseInt(this.state.inputValue)
                                                if (!this.state.inputValue || !n) {
                                                    this.setState({
                                                        swal: {}
                                                    }, () => {
                                                        this.setState({
                                                            swal: {
                                                                show: true,
                                                                title: '请输入铸造份数'
                                                            }
                                                        })
                                                    })
                                                    return
                                                }
                                                // if (n + 0 > 10000) {// 购买份数加上已经购买了的份数不能超过50份
                                                //     //todo 提示
                                                //     this.setState({
                                                //         swal: {}
                                                //     }, () => {
                                                //         this.setState({
                                                //             swal: {
                                                //                 show: true,
                                                //                 title: '铸造份数不能超过10000份'
                                                //             }
                                                //         })
                                                //     })
                                                //     return
                                                // }
                                                const amount = n * this.state.perPrice // 1份60USDT

                                                // 已铸造的+要铸造的不能超过最大数量
                                                const total = this.state.buyAmount + amount
                                                if (total > this.state.maxPayPerUser) {
                                                    this.setState({
                                                        swal: {}
                                                    }, () => {
                                                        this.setState({
                                                            swal: {
                                                                show: true,
                                                                title: `铸造总量不能超过 ${this.state.maxPayPerUser} USDT`
                                                            }
                                                        })
                                                    })
                                                    return
                                                }

                                                this.handleBuyLogic(amount)

                                            }} style={{ height: '48px' }} className="project-input-btn btn input-btn mt-2 mt-md-0 ml-md-3 approve-btn">铸造</div>
                                        </div>


                                        {/* <div className="input-box my-4">
                                        <div className="input-area d-flex flex-column flex-md-row mb-3">
                                            <div className="input-text">
                                                <input value={this.state.inputValue} onChange={(e) => {

                                                }} type="text" placeholder={0.00} />
                                                <div className="unstake-input-a">Max</div>
                                                <div onClick={() => {

                                                }} className="unstake-input-a unstake-input-a-mask">
                                                </div>
                                            </div>
                                            <div onClick={() => {



                                            }} className="btn input-btn mt-2 mt-md-0 ml-md-3 approve-btn">购买</div>
                                        </div>
                                    </div> */}

                                    </div>
                                    {/* Project Footer */}
                                    <div className="project-footer d-flex align-items-center mt-4 ">
                                        {/* <span onClick={async () => {
                                        // this.inputValue = 100
                                        this.setState({
                                            claimLoading: true
                                        })
                                        try {
                                            // 领取按钮
                                            const p = await this.initProvider()
                                            const contract = new ethers.Contract(this.state.idoContract, abi, p.getSigner())
                                            const tx = await contract.claimBuyerToken_2()
                                            await tx.wait()
                                            this.showMessageModal({
                                                show: true,
                                                title: '领取成功',
                                                icon: 'success'
                                            })
                                            this.fetchData()
                                        } catch (e) {
                                            this.handleErr(e)
                                        }

                                        this.setState({
                                            claimLoading: false
                                        })




                                    }} className="btn btn-bordered-white btn-smaller" href="/login">
                                        {this.state.claimLoading && <div>
                                            <Spinner animation="border" style={{ 'height': '16px', 'width': '16px', 'marginRight': '6px' }} variant="light" />
                                            领取中...
                                        </div>}
                                        {!this.state.claimLoading && <div>
                                            领取
                                        </div>}
                                    </span> */}
                                        {this.state.inputValue && parseInt(this.state.inputValue) > 0 && <span style={{ marginLeft: '5px' }}>
                                            {/* 可领取: {this.state.canClaimedAmount} {TokenSymbol} */}
                                            {/* 可购买: {this.state.canBuyCount} 份 */}
                                            预计花费 {parseInt(this.state.inputValue) * this.state.perPrice} USDT
                                        </span>}


                                        {/* Social Share */}

                                        <div className="social-share ml-auto">
                                            <ul className="d-flex list-unstyled">
                                                <li key={`sd_11`}>
                                                    {/* <a target="_blank" href="" rel="noreferrer"> */}
                                                    <div onClick={() => {
                                                        copy("931892714")
                                                        this.setState({
                                                            swal: {}
                                                        }, () => {
                                                            this.setState({
                                                                swal: {
                                                                    show: true,
                                                                    title: '已复制',
                                                                    text: '已复制QQ群号到剪贴板'
                                                                }
                                                            });
                                                        })
                                                    }} style={{ width: '35px', height: '35px', backgroundColor: 'white', borderRadius: '50%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                                                        <i style={{ color: 'black', fontSize: '18px' }} class="fa-brands fa-qq"></i>
                                                    </div>

                                                    {/* </a> */}
                                                </li>
                                                {this.state.socialData.map((item, idx) => {
                                                    return (
                                                        <li key={`sd_${idx}`}>
                                                            <a target="_blank" href={item.link} rel="noreferrer">
                                                                <i style={{ fontSize: '35px' }} className={item.icon} />
                                                            </a>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                    {/* Blockchain Icon */}
                                    <div className="blockchain-icon">
                                        <img src={this.state.initData.blockchain} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-7 items mt-5 mt-lg-0">
                                <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">推荐奖励
                                    </h3>
                                    <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                        一代：5%

                                        <br />
                                        二代：3%
                                        <br />
                                        下级Mint后自动秒到账
                                        <br />
                                        Mint过的用户邀请链接才生效！
                                        <br />
                                        {/* Mint截止日期 */}
                                        {/* 根据 endTime来显示,直接换算成北京时间 */}
                                        {/* {new Date(this.state.endTime * 1000).toLocaleDateString('zh-CN', { timeZone: 'Asia/Shanghai', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }).replace(/\//g, ' 月 ').replace(/ (\d+):/, ' 日 $1:')} */}
                                        GoldenDoge原庄，线上线下强强联合，王者归来 ，打造币安钻石手分红币基地，冲击币安分红币新风向标 🚀

                                    </p>

                                </div>
                                {this.state.buyAmount > 0 && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">您的邀请链接</h3>
                                    <p>
                                        {window.location.origin}?invitor={this.state.account}
                                    </p>
                                    <p>
                                        <div onClick={() => {
                                            const url = window.location.origin + '?invitor=' + this.state.account
                                            copy(url)
                                            this.setState({
                                                swal: {}
                                            }, () => {
                                                this.setState({
                                                    swal: {
                                                        show: true,
                                                        title: '已复制',
                                                        text: '已复制邀请链接到剪贴板'
                                                    }
                                                });
                                            })


                                        }} className="btn btn-bordered-white btn-smaller">
                                            复制
                                        </div>
                                    </p>

                                </div>}

                                {/* <div className=" project-card single-item-content no-hover item ml-lg-4">
                                    <img style={{ width: '100%', height: '100%', borderRadius: '2rem' }} alt="img" src="https://token-monitor.s3.amazonaws.com/17098184583122024-03-07%2021.34.03.jpg" />
                                </div> */}

                                {(this.state.invitorAddress) && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">上级地址</h3>
                                    <p style={{ 'overflow': 'hidden', 'textOverflow': 'ellipsis', 'display': '-webkit-box', 'WebkitBoxOrient': 'vertical', 'WebkitLineClamp': '2' }}>
                                        {this.state.invitorAddress}
                                    </p>
                                    <p>
                                        <div onClick={() => {
                                            copy(this.state.invitorAddress)
                                            this.setState({
                                                swal: {}
                                            }, () => {
                                                this.setState({
                                                    swal: {
                                                        show: true,
                                                        title: '已复制',
                                                        text: '已复制上级地址到剪贴板'
                                                    }
                                                });
                                            })
                                        }} className="btn btn-bordered-white btn-smaller">
                                            复制
                                        </div>
                                    </p>

                                </div>}
                                {this.state.invitorReward > 0 && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h4 className="m-0">已获得的邀请奖励:  {this.state.invitorReward} USDT</h4>
                                </div>}
                                {/* {this.state.buyAmount > 0 && <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">已购入数量:  {this.state.buyAmount} USDT</h4>
                            </div>} */}
                                {/* <div className="card project-card single-item-content no-hover item ml-lg-4"> */}
                                {/* <h4 className="m-0">邀请人数:  {this.state.invitorNumbers} </h4> */}

                                {/* </div> */}
                                {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                <h4 className="m-0">下级地址购买总量:  {this.state.invitorRefUSDTAmount.toFixed(2)}USDT </h4>
                            </div> */}
                                {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">项目背景</h3>
                                    <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                        名字意义可以从两个字的含义进行解析。龙"，在古代传说中是一种神异的动物，被视为百鳞之长，甚至被认为是生物世界的最高主宰。它象征着权力、尊贵和神秘，吉祥与幸福，龙在中国传统观念中被视为吉祥物，象征着幸福和幸运。特别是在春节等喜庆节日，人们通过舞龙、放烟火等活动来祈求吉祥和平安。在中国传统信仰中，龙被认为是吉祥的象征，用于祈求丰收、平安和幸福。龙代表着精神与气概，象征着勇敢、坚强、奋斗和不屈不挠的品质。而"泽"字含义涉及水的汇集和滋润，它不仅指代自然界的湿润环境，还引申出恩德、恩泽的概念。
                                    </p>
                                    <p>
                                        将这两个字组合在一起作为名字时，"龙泽"的寓意可能更重一些。一方面，它寓意着拥有像海洋一样宽广的胸怀和大度的气概，以及淡泊名利的品质。另一方面，也寓意着成功、有胆量、有野心，同时也代表着吉祥、幸福、平安的意思，能够得到周围人的尊敬和赞赏，家庭和睦。
                                    </p>
                                </div> */}

                                {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">DEV项目方介绍
                                    </h3>
                                    <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                        龙泽加密货币资产由shib币实力大佬联合币圈8年资深运营导师强强联手，联合发起。顶级运营手亲自操刀，势必打响2024龙年第一站！币圈线上万人社区和线下百位团队长共同参与宣发步道，全球无死角营销，对接国内外顶级kol助力龙泽出圈，吸引所有一级市场投资者参与共识打造。

                                    </p>

                                </div> */}
                                {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">营销趋势：</h3>
                                    <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                        国内多社区同步宣发（电报区+QQ区+微信区）
                                        <br />
                                        国外多社区+频道（每天宣发营销覆盖越来越多的国家），电报+推特同步宣发
                                        <br />
                                        币安广场（币安新闻）宣发
                                        <br />
                                        金色财经宣发

                                        <br />
                                        全球Youtube大营销

                                    </p>
                                </div> */}
                                {/* <div className="card project-card single-item-content no-hover item ml-lg-4">
                                    <h3 className="m-0">官方营销对接：
                                    </h3>
                                    <p className="mb-0" style={{ 'marginTop': '15px' }}>
                                        AVE和TP头像
                                        <br />
                                        电报开屏➕横屏

                                        <br />
                                        百大主流社区置顶

                                        <br />
                                        AVE热搜榜一

                                        <br />
                                        CMC及币安趋势快速通道

                                        <br />
                                        DEX头像安排中
                                        <br />
                                        交易所上市审核中

                                        <br />
                                        超强市值机构接入
                                        <br />
                                        百万营销资金投入

                                        <br />
                                        更多营销陆续安排中

                                    </p>
                                </div> */}

                            </div>






                            {this.state.invitorNumbers > 0 && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                                <h5 style={{ 'margin': '0' }}>我的邀请列表</h5>
                                {/* <div className='mt-2 d-flex flex-row' style={{ 'flexWrap': 'wrap' }} >
                                    <div>直推用户数: {this.state.invitorNumbers}</div>
                                    <div style={{ marginLeft: '10px' }}> 已获得的邀请奖励: {this.state.invitorReward} </div>
                                    <div style={{ marginLeft: '10px' }}> 间推用户数: {this.state.invitorNumbs2} </div>
                                </div> */}
                                <div style={{ 'position': 'relative' }}>
                                    <UserListTable
                                        key={'invitor-list-table'}
                                        stakeDecimals={18}
                                        rewardDecimals={18}
                                        total={this.state.invitorNumbers}
                                        perPage={15}
                                        list={this.state.invitorList}
                                        changePage={(page) => {
                                            this.getInviterList(page)
                                        }}
                                        copy={(addr) => {
                                            copy(addr)
                                            this.showMessageModal({
                                                show: true,
                                                title: '复制成功',
                                                html: `<p>${addr}</p>`,
                                                icon: 'success'
                                            })
                                        }}
                                    />
                                </div>
                            </div>}
                            {this.state.isAdmin && <div style={{ 'width': '100%' }} className='card no-hover staking-card mt-4'>
                                <h5 style={{ 'margin': '0' }}>全部用户</h5>
                                <div className='mt-2 d-flex flex-row' style={{ 'flexWrap': 'wrap' }} >
                                    <div>总计: {this.state.totalCount}</div>
                                </div>
                                <div style={{ 'position': 'relative' }}>
                                    <UserListTable
                                        key={'invitor2-list-table'}
                                        stakeDecimals={18}
                                        rewardDecimals={18}
                                        total={this.state.totalCount}
                                        perPage={15}
                                        list={this.state.allList}
                                        changePage={(page) => {
                                            this.getAllList(page)
                                        }}
                                        copy={(addr) => {
                                            copy(addr)
                                            this.showMessageModal({
                                                show: true,
                                                title: '复制成功',
                                                html: `<p>${addr}</p>`,
                                                icon: 'success'
                                            })
                                        }}
                                    />
                                </div>
                            </div>}

                            {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', marginTop: '20px' }}>
                                <h3>合作伙伴</h3>
                                <img className="hzhb" alt="" src="https://token-monitor.s3.amazonaws.com/1709828308496348ec1417d42e256f27c81a4fb8caf6d.c83d50bf.png" />
                            </div> */}
                        </div>
                    </div>
                    <SweetAlert2 {...this.state.swal} />
                </section>
            </>
        );
    }
}

function mapStateToProps(state) {
    const account = state.account;
    return {
        account,
        // text
    };
}

// export default ProjectSingle;
export default connect(mapStateToProps)(ProjectSingle)